// .........Imports..........
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Cookies from "universal-cookie";
// .........Icon imports......
import validIcon from "../../../assets/images/register/green_check.svg";
import editIcon from "../../../assets/images/register/edit.png";
// ........Action imports...........
import { getEmailDomainData, getUserAuthenticationEmail, clearLoginDataResponse } from "../../../../store/slices/Registration/CommonSlices";
// .......Component imports.........
import CommonModal from "../../utils/commonModal";
// .......Utils import........
import { deviceType } from "../../../utils/registrationUtils";
import {gaEvent, gaLocationAndContentData} from "../../../utils/index";


const EmailInputLogin = (props) => {
    // Destructuring props for easier access to formik properties and methods
    const {
        values,
        name,
        setFieldValue,
        errors,
        touched,
        handleBlur,
    } = props;

    // State variables to manage dropdown, filtered domains, modal visibility, etc.
    const [showDropdown, setShowDropdown] = useState(false);
    const [filteredDomains, setFilteredDomains] = useState([]);
    const [show, setShow] = useState(false);
    const cookies = new Cookies();
    const [blockMailDomains, setBlockMailDomains] = useState([]);
    const [highlightedIndex, setHighlightedIndex] = useState(-1);

    // Effect to handle email domain data changes
    useEffect(() => {
        if (props.emailDomainDatas) {
            const emailDomainsArray = props.emailDomainDatas?.values?.map(item => item.value) ?? [];
            const uniqueEmailDomains = [...new Set(emailDomainsArray)]; //to remove duplicate data
            setBlockMailDomains(uniqueEmailDomains);
        }

        // Handle click outside of dropdown to close it
        const handleOutsideClick = (event) => {
            const dropdown = document.getElementById('emailDropdown');
            // Check if the click is outside the dropdown and input
            if (dropdown && !dropdown.contains(event.target) && event.target !== document.getElementById('emailInput')) {
                setShowDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleOutsideClick);
        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
        };
    }, [props.emailDomainDatas]);

     // Handle input change and validate email format
     const handleInputChange = (e, name) => {
        let value = e.target.value;
        const emailValidations = /[^a-zA-Z0-9@_.-]|(\.{2,})|@.*@|\s{2,}|^_|_{2,}|[._-]{2,}|^\.|(\.@|_@)|^[\s]|[\s]$|@[^a-zA-Z0-9.]|@.*\.{4,}|@[.]{2,}|@.*_|^-|.*-@|@.*-/;
        const prevValue = values[name] ?? '';
        if (value && emailValidations.test(value)) {
            setFieldValue("email", prevValue);
            value = prevValue;
            e?.preventDefault();
            return;
        }
        if (value?.includes("@")) {
            const afterAt = value.split("@")[1];
            if (afterAt.startsWith(".") || afterAt.split(".").length - 1 >= 3 || afterAt.includes("@")) {
                e?.preventDefault();
                return;
            }
        }
        setFieldValue("email", value);
        if (value) {
          if (value?.includes("@")) {
          setShow(true); // Show the modal (Mobile case)
          setHighlightedIndex(-1); // Reset highlighted index
          const domainPart = value.split("@")[1];
          const filtered = blockMailDomains?.filter((domain) =>
          domain?.startsWith(domainPart)
          );
          // Check if the typed domain is in the filtered domains
          if (filtered?.includes(domainPart) || value?.includes(".com")) {
          setShowDropdown(false);
          } else {
          setShowDropdown(true);
          }
          setFilteredDomains(filtered);
          } 
          else {
          setShowDropdown(false);
          }
        }
    };

     // Effect to handle keydown events for email input
    useEffect(() => {
        const emailInput = document.getElementById('emailInput');
        const emailDropdown = document.getElementById('emailDropdown');
    
        const handleKeyDown = (event) => {
          const key = event.key;
          const options = emailDropdown?.querySelectorAll('li');
          const totalOptions = options?.length;
    
          if (key === 'ArrowUp' || key === 'ArrowDown') {
            event.preventDefault();
            if (key === 'ArrowUp') {
              setHighlightedIndex((prevIndex) => {
                if (prevIndex === -1) return totalOptions - 1; // If no selection, highlight the last option
                return (prevIndex - 1 + totalOptions) % totalOptions; // Move to the previous option
              });
            } else if (key === 'ArrowDown') {
              setHighlightedIndex((prevIndex) => {
                if (prevIndex === -1) return 0; // If no selection, highlight the first option
                return (prevIndex + 1) % totalOptions; // Move to the next option
              });
            }
            // Update highlighted class for dropdown options    
            options.forEach((option, index) => option.classList.toggle('email_dropdown_highlighted', index === highlightedIndex));
          } else if (key === 'Enter') {
            event.preventDefault();
            if (highlightedIndex !== -1) {
              const selectedDomain = options[highlightedIndex]?.textContent;
              const filteredValue = selectedDomain.includes('@') ? selectedDomain.split('@')[0] : selectedDomain;
              emailInput.value = filteredValue;
              setFieldValue("email", emailInput.value.replace(/@[^@]*$/, selectedDomain));// Set email value with selected domain
              handleDropdownSelect(selectedDomain);// Handle dropdown selection
              setShowDropdown(false);
            }
          }
        };
    
        if (emailInput && emailDropdown) {
          emailInput.addEventListener('keydown', handleKeyDown);
        }
    
        return () => {
          if (emailInput && emailDropdown) {
            emailInput.removeEventListener('keydown', handleKeyDown);
          }
        };
      }, [highlightedIndex, showDropdown]);


    // Handle dropdown selection
    const handleDropdownSelect = (domain) => {
        // Add the selected domain to the input value
        setFieldValue("email", values?.email?.replace(/@[^@]*$/, `@${domain}`));
        setShowDropdown(false); // Close the dropdown
        setShow(false); //close the modal
    };

    // Handle focus event for the input field
    const handleIsFocused = () => {
        // e.preventDefault();
        props.updateTouchedFields({ ...touched, [`${name}`]: true })
    }

    // Handle email edit event
    const handleEmailEdit = () => {
        gaEvent("otpchangeemailsignin", "login_signup", `${gaLocationAndContentData}`, "");
        props.dispatch(clearLoginDataResponse())
        let params = {};
        params.email = props.values?.email;
        params.check_otp = 1;
        props.dispatch(getUserAuthenticationEmail(params))
        props.setFormCurrentState((prev) => ({ ...prev, sendOtpToEmail: null }))
    }


    // Show error message
    const showErrorMessage = () => {
        return (
            <>
                {/* to show email validation message */}
                {errors.email && touched.email && (
                    <div className="invalid_card">
                        <span className="invalid_card_text">{errors.email}</span>
                    </div>
                )}
                {props.postSignupData?.message?.includes("email") && <div className="invalid_card">
                    <span className="invalid_card_text">{props.postSignupData?.message}</span>
                </div>}

                {/* to show the error message in case of otp limit exceed or user gets blocked */}
                {(props.userAuthenticationEmailError?.authorization == false || props.userLoginSignupOtpError?.block_user_case == "user_restricted"
                    || props.userLoginSignupOtpError?.block_user_case == "otp_exceed") && !errors?.email &&
                    <div className="invalid_card">
                        {props.userAuthenticationEmailError?.block_user_case === "invalid_email_domain" ?
                            <span className="invalid_card_text">{props.userAuthenticationEmailError?.message}</span> :
                            <span className="invalid_card_text">Email error, <a href="https://www.careers360.com/grievance-redressal" className="contact_support_text">contact support</a></span>}
                    </div>
                }
            </>
        )
    }

    // Show edit/valid icon on otp verification page
    const showEditorValidIcon = () => {
        return (
            (props.loginDatas?.required_field?.includes("email_otp") || cookies.get("loginState")?.sendOtpToEmail?.otp_action === "send") ? (
                <div onClick={() => {handleEmailEdit();}} className="edit_card">
                    <img src={editIcon} alt="edit_icon" />
                    <span>Edit</span>
                </div>
            ) : (
                props.userAuthenticationEmail && (!errors.email || !cookies.get("loginState")?.errors?.email) ? (
                    <img src={validIcon} alt="careers_register_checkIcon" className="careers_register_valid_icon" />
                ) : null
            )
        )
    }

    const showEmailSuggestion = () => {
        return (
            <ul id="emailDropdown" className={values?.email?.includes(filteredDomains) ? "" : "careers_register_email_dropdown"}>
                {filteredDomains?.map((domain, index) => (
                    <li key={index} onClick={() => handleDropdownSelect(domain)} className={highlightedIndex === index ? 'email_dropdown_highlighted' : ''}>
                        {domain}
                    </li>
                ))}
            </ul>
        )
    }

    return (
        <>
            {deviceType == "web" && (
                <div className={(errors?.email && touched?.email) || props.postSignupData?.message?.includes("email")
                    || props.userAuthenticationEmailError?.authorization == false ? "careers_register_form_card text_input invalid_field" : values?.email ? "careers_register_form_card text_input white_bg" : "careers_register_form_card text_input"}>

                    {props.loginDatas?.required_field?.includes("email_otp") || cookies.get("loginState")?.sendOtpToEmail?.otp_action ?
                        <>
                            <input
                                type="text"
                                value={values.email ?? props.loginDatas?.user_email}
                                name={name}
                                onBlur={handleBlur}
                                className="input_type_text"
                                readOnly
                            />
                            <span className={values?.email ? 'floating_label_active' : 'floating_label'}>{'Email'}</span>
                        </>
                        :
                        <>
                            <input
                                type="text"
                                id="emailInput"
                                value={values?.email}
                                name={name}
                                className="input_type_text"
                                onBlur={handleBlur}
                                onChange={(e) => {
                                    handleInputChange(e, name);
                                }}
                                ref={props.mobileInputRef}
                                onFocus={() => handleIsFocused()}
                            />
                            <span className={values?.email ? 'floating_label_active' : 'floating_label'}>Email</span>
                        </>
                    }

                    {/* on email otp verification screen if user submit the email it has the edit option otherwise valid icon  */}
                    {showEditorValidIcon()}

                    {/* to show email validation message */}
                    {showErrorMessage()}

                    {/* to show the email domain suggestion in dropdown */}
                    {showDropdown && showEmailSuggestion()}
                </div>
            )}

            {deviceType == "mobile" && (
                <>
                    <div className={(errors.email && touched.email) || props.postSignupData?.message?.includes("email") || props.userAuthenticationEmailError?.authorization == false
                        ? "careers_register_form_card text_input invalid_field" : values?.email ? "careers_register_form_card text_input white_bg" : "careers_register_form_card text_input"}>
                        {props.loginDatas?.required_field?.includes("email_otp") || cookies.get("loginState")?.sendOtpToEmail?.otp_action ?
                        <>
                            <input
                                type="text"
                                value={values.email ?? props.loginDatas?.user_email}
                                name={name}
                                onBlur={handleBlur}
                                className="input_type_text"
                                readOnly
                                autoFocus={false}
                            />
                        </>
                        :
                         <>
                         <input
                            type="email"
                            value={values?.email}
                            name={name}
                            onClick={() => setShow(true)}
                            // onFocus={() => handleIsFocused()}
                            className="input_type_text"
                            // onBlur={handleBlur}
                            onChange={(e) => {
                                handleInputChange(e, name);
                            }
                            }
                            readOnly
                        />
                        </>
                    } 
                    <span className={values?.email ? 'floating_label_active' : 'floating_label'}>Email</span> 
                        
                        {showEditorValidIcon()}

                        {/* to show email validation message */}
                        {!show && showErrorMessage()}

                    </div>

                    {/* opens a modal for mobile view */}
                    <CommonModal
                        isOpen={show}
                        closeModal={() => setShow(false)}
                        classNames={{
                            root: "mobile_modal mobile_modal_email",
                            modal: 'custom_modal',
                            modalAnimationIn: 'customEnterModalAnimation',
                            modalAnimationOut: 'customLeaveModalAnimation',
                        }}
                        animationDuration={800}
                    >
                        <div className={(errors.email && touched.email) || props.postSignupData?.message?.includes("email") ? "careers_register_form_card text_input invalid_field email_wrapper" : values?.email ? "careers_register_form_card text_input white_bg email_wrapper" : "careers_register_form_card text_input email_wrapper"}>
                            <>
                                <input
                                    type="email"
                                    autoComplete="off"
                                    value={values?.email}
                                    name={name}
                                    className="input_type_text"
                                    onBlur={handleBlur}
                                    onChange={(e) => {
                                        handleInputChange(e, name);
                                    }
                                    }
                                    onFocus={() => handleIsFocused()}
                                />
                                <span className={values.email ? 'floating_label_active' : 'floating_label'}>{'Email'}</span></>
                            {/* to show the email domain suggestion in dropdown */}
                            {showDropdown && showEmailSuggestion()}

                        </div>
                        <div className="email_wap_done_cta_cover">
                          <button onClick={() => setShow(false)} className="email_done_cta">Done</button>
                        </div>

                    </CommonModal>
                </>
            )}
        </>
    );
};
const mapStateToProps = (state) => {
    return {
        emailDomainDatas: state.usersCommonData?.emailDomainData,
        userLoginSignupOtp: state.usersCommonData.userLoginSignupOtp,
        userLoginSignupOtpError: state.usersCommonData?.userLoginSignupOtpError,
        postSignupData: state.userSignUpFields?.signupDataError,
        userAuthenticationEmail: state.usersCommonData?.userAuthenticationEmail,
        userAuthenticationEmailError: state.usersCommonData?.userAuthenticationEmailError,
        loginDatas: state.usersCommonData?.loginData,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        dispatch,
    };
};
export default connect(
    mapStateToProps,
    mapDispatchToProps
)(EmailInputLogin);